import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Usuario } from 'src/app/model/index.model';
import { UsuarioService } from 'src/app/service/index.service';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';

@Component({
  selector: 'app-user-registro',
  templateUrl: './user-registro.component.html',
  styleUrls: ['./user-registro.component.scss']
})
export class UserRegistroComponent implements OnInit {
  @Output() fin = new EventEmitter<Boolean>();
  @Input() conf: any

  /*
    * control de operaciones a realizar
    */
  proccess: Boolean;

  public entity = 'usuarios';
  public item: Usuario;
  private id: number;

  constructor(private wsdl: UsuarioService) {
    this.item = new Usuario();
  }

  ngOnInit() {
  }

  doAction(f: NgForm) {
    /* validar */
    if (f.valid) {
      this.doCreate();
    } else {
      alert('Validar');
    }
  }
  async doCreate() {
    try {

      this.proccess = true;
      const res = await this.wsdl.doInsert(this.item).then();
      const result = JSON.parse(JSON.stringify(res));
      if (result.code == 200) {
        this.item = new Usuario();
        UturuncoUtils.showToas(result.msg, "success");
        this.fin.emit(true)

      } else if (result.code == 666) {
        // logout app o refresh token
      } else {
        UturuncoUtils.showToas(result.msg, "error");
      }
    } catch (error) {
      this.fin.emit(false)

      UturuncoUtils.showToas("Excepción: " + error.message, "error");
    } finally {
      this.proccess = false
    }
  }
}
